import {
    WxxdDetail,
    WxxdEdit,
    wxxdBatchUpdateCategory,
    wxxdDetailSupplier,
} from '@/api/prod/center/index'


// 过滤上传失败或为空的图片
export function _filterInvalidImg(imgsArr) {
    return imgsArr.filter(img => {
        if (!img) {
            return false
        } else if (typeof img === 'object') {
            return false
        } else {
            return true
        }
    })
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
    if (r.skuList && r.skuList.length > 0) {
        r.skuList = r.skuList.map(item => {
            return isRequest ? {
                ...item,
                skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
            } : {
                ...item,
                skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
            }
        })
    }

    return isRequest ? {
        ...r,
        categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
        headImgs: JSON.stringify(r.headImgs ? _filterInvalidImg(r.headImgs) : []),
        descInfo: JSON.stringify(r.descInfo ? _filterInvalidImg(r.descInfo) : []),
        specifications: JSON.stringify(r.specifications ? r.specifications : []),
        categoryIds: r.categoryIds ? r.categoryIds.join(',') : ''
    } : {
        ...r,
        attrs: r.attrs ? r.attrs : [],
        categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
        headImgs: r.headImgs ? JSON.parse(r.headImgs) : [],
        descInfo: r.descInfo ? JSON.parse(r.descInfo) : [],
        specifications: r.specifications ? JSON.parse(r.specifications) : [],
        categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
        templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
        productType: 1, // 目前只支持实物商品
    }
}

// 编辑详情
export function editWxxdDetail(data) {
    return WxxdEdit(_formatGoodsItem(data, true)).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

// 获取详情资料
export function getWxxdDetail(baseItemId) {
    return WxxdDetail({
        baseItemId
    }).then(res => {
        if (res.result === 1) {
            return _formatGoodsItem(res.data)
        } else {
            return false
        }
    })
}

// 获取详情资料(供销商小店版)
export function getWxxdDetailSupplier(params) {
    return wxxdDetailSupplier(params).then(res => {
      if (res.result === 1) {
        // debugger;
        return _formatGoodsItem(res.data)
      } else {
        return false
      }
    })
  }

// 批量修改类目
export function batchWxxdCategory(data) {
    return wxxdBatchUpdateCategory(data).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}
